import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout } from 'antd';
import styles from './Header.less';
import { toLogin } from '@/lib/lib';

const { Header } = Layout;

@inject('loginStore')
@observer
class PublicHeader extends Component {
  render() {
    const userName = this.props.loginStore.userName;
    return (
      <Header className={styles.header}>
        <div className={styles.logo} />
        {userName && (
          <div className={styles.user}>
            <span>欢迎, {userName}</span>
            <span className={styles.loginOut} onClick={() => toLogin()}>
              退出登录
            </span>
          </div>
        )}
      </Header>
    );
  }
}

export default PublicHeader;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js